import { CustomValidatorArgs } from '../types/CSVTypes';
import { validatePhoneWithCountryCode } from '../../../../helpers/forms/phoneUtils';

const phoneValidator = ({ value, countryCode }: CustomValidatorArgs) => {
  if (!!value && !validatePhoneWithCountryCode(value, countryCode)) {
    return 'invalidPhone';
  }

  return null;
};

export default phoneValidator;
